import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { RoutePath } from '@quizzach/interfaces';

/**
 * Every route lands at the top of the page. useLayoutEffect (not useEffect)
 * so the scroll happens before the browser paints the new route — the jump
 * is never visible, the page simply appears already scrolled to the top.
 * The search string is part of the key because list pages page through
 * ?page= without changing the pathname. The gift shop is the exception: its
 * query marks sections and views of one page, and it handles its own scrolling.
 */
export const ScrollToTop = () => {
	const { pathname, search } = useLocation();
	const route = pathname === RoutePath.Voucher ? pathname : pathname + search;

	useLayoutEffect(() => {
		// browsers otherwise restore the previous offset after our scroll
		if ('scrollRestoration' in window.history) {
			window.history.scrollRestoration = 'manual';
		}
		window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
		// some layouts scroll an inner element instead of the window
		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;
	}, [route]);

	return null;
};
